import config from 'tradera-apps/syi/script/app_react/services/config';

function isValidPrice(number) {
    var str = new String(number);
    if (!Number.isFinite(parseInt(str))) {
        return false;
    } else if (str.indexOf('.') > -1) {
        return false;
    } else if (str.indexOf(',') > -1) {
        return false;
    }
    return true;
}

function isInt(number) {
    return number % 1 === 0;
}

function validateOpeningBid({ isPureBinSelected, openingBid }) {
    if (isPureBinSelected) {
        return null;
    }

    if (openingBid && !isInt(openingBid)) {
        return 'syi_validation_amount_must_be_whole_number';
    }

    var maxPrice = 10000000;
    var minPrice = 1;

    if (!isValidPrice(openingBid)) {
        return 'syi_validation_opening_bid_missing';
    }

    if (openingBid > maxPrice) {
        return 'syi_validation_max_opening_bid';
    }

    if (openingBid < minPrice) {
        return 'syi_validation_minimum_opening_bid';
    }

    return null;
}

function validateReservePrice({
    isPureBinSelected,
    showReservePrice,
    openingBid,
    reservePrice,
    auctionBinPrice
}) {
    if (isPureBinSelected) {
        return null;
    }

    if (showReservePrice && !reservePrice) {
        return 'syi_validation_amount_missing';
    }

    if (reservePrice && !isInt(reservePrice)) {
        return 'syi_validation_amount_must_be_whole_number';
    }

    var maxPrice = 10000000;

    if (reservePrice && !isValidPrice(reservePrice)) {
        return 'syi_validation_invalid_reservation_price';
    }

    let reservePriceIsLessThanOpeningBid =
        reservePrice && reservePrice <= openingBid;
    if (reservePriceIsLessThanOpeningBid) {
        return 'syi_validation_reservation_must_be_larger_than_starting';
    }

    let reservePriceIsGreaterThanAuctionBinPrice =
        reservePrice && auctionBinPrice && reservePrice >= auctionBinPrice;
    if (reservePriceIsGreaterThanAuctionBinPrice) {
        return 'syi_validation_reservation_must_be_less_than_buy_now';
    }

    if (reservePrice > maxPrice) {
        return 'syi_validation_max_reservation_price';
    }

    return null;
}

function validateAuctionBinPrice({
    isPureBinSelected,
    showAuctionBinPrice,
    openingBid,
    reservePrice,
    auctionBinPrice
}) {
    if (isPureBinSelected) {
        return null;
    }

    if (showAuctionBinPrice && !auctionBinPrice) {
        return 'syi_validation_amount_missing';
    }

    if (auctionBinPrice && !isInt(auctionBinPrice)) {
        return 'syi_validation_amount_must_be_whole_number';
    }
    let auctionBinPriceIsLessThanOpeningBid =
        auctionBinPrice && auctionBinPrice <= openingBid;
    if (auctionBinPriceIsLessThanOpeningBid) {
        return 'syi_validation_buy_now_must_be_larger_than_starting';
    }

    let reservePriceIsGreaterThanAuctionBinPrice =
        reservePrice && auctionBinPrice && reservePrice >= auctionBinPrice;
    if (reservePriceIsGreaterThanAuctionBinPrice) {
        return 'syi_validation_buy_now_must_be_larger_than_reservation';
    }
    return null;
}

function validateFixedPrice({ isPureBinSelected, fixedPrice }) {
    if (!isPureBinSelected) {
        return null;
    }

    if (fixedPrice && !isInt(fixedPrice)) {
        return 'syi_validation_amount_must_be_whole_number';
    }

    var maxPrice = 10000000;
    var minPrice = 1;

    if (!isValidPrice(fixedPrice)) {
        return 'syi_validation_enter_fixed_price';
    }
    if (!isNaN(fixedPrice)) {
        if (parseInt(fixedPrice) > maxPrice) {
            return 'syi_validation_fixed_price_max_value';
        }

        if (parseInt(fixedPrice) < minPrice) {
            return 'syi_validation_fixed_price_min_value';
        }
    }
    return null;
}

function validate(newState) {
    const validationErrors = {};

    validationErrors.fixedPrice = validateFixedPrice(newState);
    validationErrors.openingBid = validateOpeningBid(newState);
    validationErrors.auctionBinPrice = validateAuctionBinPrice(newState);
    validationErrors.reservePrice = validateReservePrice(newState);

    for (const errorKey in validationErrors) {
        if (!validationErrors[errorKey]) delete validationErrors[errorKey];
    }

    newState.validationErrors = validationErrors;

    return newState;
}

const queryParams = new URLSearchParams(window.location.search);
var initialState = {
    openingBid: null,
    auctionBinPrice: null,
    fixedPrice: null,
    reservePrice: null,
    showAuctionBinPrice: false,
    showReservePrice: false,
    showCharityDonation: Boolean(queryParams.get('charityId')),
    editCharity: false,
    isPureBinSelected: null,
    validationErrors: {},
    selectableVats: config.selectableVatValues,
    reservePriceCanChangeButNotBeRemoved: false,
    vat: null
};

export default (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case 'SET_OPENING_BID':
            return validate({ ...state, openingBid: action.payload });
        case 'SET_AUCTION_BIN_PRICE':
            return validate({ ...state, auctionBinPrice: action.payload });
        case 'SET_FIXED_PRICE':
            return validate({ ...state, fixedPrice: action.payload });
        case 'SET_RESERVE_PRICE':
            return validate({ ...state, reservePrice: action.payload });
        case 'SET_AUCTION_BIN_PRICE_VISIBILITY':
            return validate({ ...state, showAuctionBinPrice: action.payload });
        case 'SET_RESERVE_PRICE_VISIBILITY':
            return validate({ ...state, showReservePrice: action.payload });
        case 'SET_CHARITY_DONATION_VISIBILITY':
            return validate({ ...state, showCharityDonation: action.payload });
        case 'SET_EDIT_CHARITY':
            return validate({ ...state, editCharity: action.payload });
        case 'SET_IS_PURE_BIN_SELECTED':
            return validate({
                ...state,
                isPureBinSelected: action.isPureBinSelected
            });
        case 'SET_VAT':
            return validate({ ...state, vat: action.payload });
        case 'RESET_PRICES_AND_VAT':
            return validate({
                ...state,
                openingBid: null,
                auctionBinPrice: null,
                fixedPrice: null,
                vat: null
            });
        case 'SET_RESERVE_PRICE_CAN_CHANGE_BUT_NOT_BE_REMOVED':
            return validate({
                ...state,
                reservePriceCanChangeButNotBeRemoved: action.payload
            });
        default:
            return state;
    }
};
